import { render } from "./WawaThree.vue?vue&type=template&id=1e785b20"
import script from "./WawaThree.vue?vue&type=script&lang=js"
export * from "./WawaThree.vue?vue&type=script&lang=js"

import "./WawaThree.vue?vue&type=style&index=0&id=1e785b20&lang=css"
script.render = render

export default script